"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const svgProps = {
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    focusable: 'false',
    'aria-hidden': 'true'
};
function withSVGAttributes(Component) {
    const displayName = Component.displayName || Component.name || 'Component';
    const WrappedComponent = /*#__PURE__*/ forwardRef((props, ref)=>{
        const { role, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-hidden': ariaHiddenProp, ...restProps } = props;
        const hasAccessibleName = Boolean(ariaLabel || ariaLabelledBy);
        const finalRole = 'img' === role && hasAccessibleName ? 'img' : void 0;
        const finalAriaHidden = 'img' === finalRole ? void 0 : ariaHiddenProp ?? svgProps['aria-hidden'];
        const mergedProps = {
            ...restProps,
            ...svgProps,
            'aria-hidden': finalAriaHidden,
            ref,
            ...finalRole && {
                role: finalRole
            }
        };
        return /*#__PURE__*/ jsx(Component, {
            ...mergedProps
        });
    });
    WrappedComponent.displayName = `withSVGAttributes(${displayName})`;
    return WrappedComponent;
}
var SVG_withSVGAttributes = withSVGAttributes;
export default SVG_withSVGAttributes;
export { withSVGAttributes };
